import * as React from 'react';
import useStyles from './Auth0Widget.styles';
import { DeactivatedIcon } from '../../pages/ErrorPage/DeactivatedIcon';
import { Icon } from '../../atoms';
import { useTheme } from 'react-jss';
import { CustomCiamUiTheme } from '../../../theme';

export interface IAuth0WidgetProps {
  description?: JSX.Element;
  title?: JSX.Element;
  isError?: boolean;
  children?: JSX.Element;
  renderBackLink?: JSX.Element;
  showEmailIcon?: boolean;
}

const Auth0Widget: React.FC<IAuth0WidgetProps> = ({
  description,
  title,
  isError = false,
  children,
  renderBackLink,
  showEmailIcon,
}) => {
  const theme = useTheme<CustomCiamUiTheme>();
  const classes = useStyles({ theme });

  return (
    <div className={classes.widget}>
      {isError && (
        <div className={classes.errorIcon}>
          <DeactivatedIcon />
        </div>
      )}
      {showEmailIcon && (
        <div className={classes.mailIcon}>
          <Icon type="mail" />
        </div>
      )}
      <div className={isError ? classes.headerWithError : classes.header}>
        <div className={classes.title}>{title}</div>
        {description && (
          <div className={classes.description}>{description}</div>
        )}
      </div>
      <div className={classes.form}>{children}</div>
      {renderBackLink && (
        <div className={classes.renderedLink}>{renderBackLink}</div>
      )}
    </div>
  );
};

export default Auth0Widget;
